var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrowMobile = function SvgLeftArrowMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E5EBEE",
    strokeWidth: 1.5,
    d: "M.75 15C.75 7.13 7.13.75 15 .75S29.25 7.13 29.25 15 22.87 29.25 15 29.25.75 22.87.75 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0265dc",
    strokeWidth: 3,
    d: "M13.97 19.213 9.656 14.9l4.314-4.314M20.899 14.899H9.568"
  })));
};
export { SvgLeftArrowMobile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNzQ5OTk4IDE1QzAuNzUgNy4xMjk5NCA3LjEyOTk1IDAuNzUgMTUgMC43NTAwMDJDMjIuODcwMSAwLjc1MDAwNCAyOS4yNSA3LjEyOTk1IDI5LjI1IDE1QzI5LjI1IDIyLjg3MDEgMjIuODcwMSAyOS4yNSAxNSAyOS4yNUM3LjEyOTk0IDI5LjI1IDAuNzQ5OTk2IDIyLjg3MDEgMC43NDk5OTggMTVaIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjRTVFQkVFIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMTMuOTY5OSAxOS4yMTMyTDkuNjU1NjUgMTQuODk4OUwxMy45Njk5IDEwLjU4NDciIHN0cm9rZT0iIzAyNjVkYyIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxwYXRoIGQ9Ik0yMC44OTg5IDE0Ljg5ODlMOS41Njc5NiAxNC44OTg5IiBzdHJva2U9IiMwMjY1ZGMiIHN0cm9rZS13aWR0aD0iMyIvPgo8L3N2Zz4K";